module.exports = __webpack_public_path__ + "static/media/facebook-icon.296708a0.png";